import { createContext, useContext } from "react";

const CompanyContext = createContext(null);

export const CompanyProvider = CompanyContext.Provider;
export const useCompany = () => {
  return useContext(CompanyContext);
};
